import React from 'react'

export const Loading = (props) => (
   <div>
       <p>Loading...</p>
   </div> 
 )
